export const tagCategories = {
  PoliticalContext: "Contexto político",
  SocialContext: "Contexto social",
  BiologicalGroup: "Grupo biológico",
  Ecosystem: "Ecosistema",
};
